import classNames from 'classnames';
import { ErrorMessage, Field, useFormikContext } from 'formik';
import React, { memo, useContext, useState } from 'react';
import { FormFieldToolTipBlokProps } from '../FormFields/FormFieldToolTip/FormFieldToolTip';
import { QuickQuoteContext } from '../../contexts/QuickQuote.context';
import QuoteFormBuyingErrorMessage from '../QuoteForm/QuoteFormBuyingErrorMessage';
import { pushToDataLayer } from '../../utils/pushToDataLayer/pushToDataLayer.util';

interface QuickQuoteSingleOptionSelectProp {
  placeholder: string;
  name: string;
  description?: string;
  is_required: boolean;
  error_message?: string;
  tool_tip?: FormFieldToolTipBlokProps[];
  toolTipLabel?: string;
  options: string[];
}

const QuickQuoteSingleOptionSelect: React.FC<
  QuickQuoteSingleOptionSelectProp
> = ({
  placeholder,
  name,
  description = undefined,
  is_required,
  error_message = undefined,
  tool_tip = [],
  options,
}) => {
  const { errors, touched, values } = useFormikContext<any>();

  const handleDataLayerClickEvent = (label: string): void => {
    pushToDataLayer({
      event: 'quote_dropdown',
      data: {
        quote_funnel_journey: label,
        quote_cta_url: window.location.href,
      },
    });
  };

  return (
    <>
      <div
        className={classNames(
          'h-14 flex items-center justify-start bg-system/white border border-border/default rounded-default overflow-clip',
          {
            'border-border/error': errors[name] && touched[name],
            'border-border/success': !errors[name] && touched[name],
          }
        )}
      >
        <Field
          as="select"
          name={name}
          className={`w-full flex-1 border-none h-full appearance-none blur:bg-system/White autofill:shadow-[inset_0_0_0px_1000px_#ffffff] focus:!ring-0 focus:!outline-none ${
            values['title'] ? 'text-[#000]' : 'text-[#646e73]'
          }`}
        >
          <option
            value=""
            // selected
            disabled
            hidden
            className="placeholder-option"
          >
            {placeholder}
          </option>
          {options.map((option) => (
            <option key={option} value={option}>
              {option}
            </option>
          ))}
        </Field>
      </div>
      <ErrorMessage
        name={name}
        render={(msg) => {
          return <QuoteFormBuyingErrorMessage error={msg} />;
        }}
      />
    </>
  );
};

export default memo(QuickQuoteSingleOptionSelect);
